import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikTextArea } from 'components/UiKit/FormikFields';

const LegalDescription = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikTextArea
      id="legalName"
      name="legalName"
      label="Legal Description"
      disabled={!isEnableInfoTabEdit}
      placeholder="Enter legal description"
    />
  );
};

export default LegalDescription;
